import { defineComponent } from 'vue';
import { Tabbar, TabbarItem } from 'vant';
import PopupPublishService from './Popup/PopupPublishService';
import UIService from 'pk/service/UIService';
import NotifyService from '@/service/Notify/NotifyService';
import RouterService from '@/service/RouterService';
export default defineComponent({
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem
  },
  data() {
    return {
      PopupPublishService: new PopupPublishService(),
      active: 0
    };
  },
  watch: {
    $route() {
      this.active = this.getActive();
      this.drElement.reload();
    }
  },
  computed: {
    badge() {
      return NotifyService.unreadCount || null;
    },
    drElement() {
      return this.$refs.drElement;
    }
  },
  created() {
    this.active = this.getActive();
  },
  methods: {
    handleAction() {
      return this.PopupPublishService.open().catch(err => UIService.toast.bizFail(err));
    },
    getActive() {
      if (RouterService.getPath().includes('/hr/job/show') || RouterService.getPath().includes('/hr/resume/show')) {
        return -1;
      }
      if (RouterService.getPath().includes('/hr/job')) {
        return 1;
      } else if (RouterService.getPath().includes('/hr/resume')) {
        return 3;
      } else {
        return 0;
      }
    }
  }
});